"use strict";

exports.__esModule = true;
var _ElementEditorSaveTemplateDialog = require("./ElementEditorSaveTemplateDialog");
Object.keys(_ElementEditorSaveTemplateDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementEditorSaveTemplateDialog[key]) return;
  exports[key] = _ElementEditorSaveTemplateDialog[key];
});